import { CustomTooltip } from "@/ui";
import { Box } from "@mui/material";
import { FC } from "react";
import { IStatusDoid } from "./StatusDiod.props";
import { GreenDiod, OrangeDiod, RedDiod, GrayDiod } from "./StatusDiod.styles";
import { useTranslate } from "@/hooks";

const StatusDiod: FC<IStatusDoid> = ({ color, text, diodParams, pulsing = true, withTooltip = true, ...props }) => {
	const translate = useTranslate();
	const defaultDiodParams = { width: 12, height: 12, top: 12, left: 12, zIndex: 3, ...diodParams };

	let DiodComponent: React.ElementType | null = null;

	switch (color) {
		case "green":
			DiodComponent = GreenDiod;
			break;
		case "red":
			DiodComponent = RedDiod;
			break;
		case "orange":
			DiodComponent = OrangeDiod;
			break;
		case "gray":
			DiodComponent = GrayDiod;
			break;
	}

	if (!DiodComponent) return null;

	const diod = (
		<Box
			position="absolute"
			width={defaultDiodParams.width}
			height={defaultDiodParams.height}
			top={defaultDiodParams.top}
			left={defaultDiodParams.left}
			zIndex={defaultDiodParams.zIndex}
			{...props}
		>
			<DiodComponent pulsing={pulsing} />
		</Box>
	);

	if (!withTooltip) return diod;

	return <CustomTooltip title={[{ [`${translate("title_status")}:`]: text }]}>{diod}</CustomTooltip>;
};

export default StatusDiod;
